export default __webpack_public_path__ + "static/media/driver_place_holder.c68b3612.svg";